import axios, { AxiosResponse } from 'axios';

import { ERozsahPPN } from 'services/dokumenty/navyseni';

import { EStavPozadavku } from 'enums/specialniSluzby/stavPozadavku';
import { ETypPozadavku } from 'enums/specialniSluzby/typPozadavku';
import { ETypTransakce } from 'enums/specialniSluzby/typTransakce';

export interface IPozadavkyPolozka {
    idpolozky?: number;
    koducastnika?: string;
    ucet?: string;
    idnabyvatele?: string;
    pocetcp?: string | number;
    idvlastnika?: string;
    prijmeni?: string;
    jmeno?: string;
    cislozastavnismlouvy?: string;
    idf24?: string;
    stav?: string;
    sankce?: boolean;
    idprevoduvCDCP?: string;
    zpusobporizeni?: string;
    poznamka?: string;
    zdrojdat?: string;
    ppn?: boolean;
    zpusobpor?: string;
    typtransakce?: ETypTransakce;
    upozorneni?: string;
    idvcdcp?: string;
    idvisb?: string;
    uzivatel?: string;
    meznidatumprozruseni?: string;
    lzeevidovatod?: string;
    order?: string;
    offset?: number;
    page?: number;
    limit?: number;
    isin?: string; // Extra položka mimo API
    datum?: string; // Extra položka mimo API
}

export interface IPozadavky {
    id?: number;
    typ?: ETypPozadavku;
    isin?: string;
    datum?: string;
    pocetcp?: number;
    zaevidovanecp?: number;
    nezaevidovanecp?: number;
    vyporadanecp?: number;
    nevyporadanecp?: number;
    pocetuctu?: number;
    zaevidovaneucty?: number;
    nezaevidovaneucty?: number;
    vyporadaneucty?: number;
    nevyporadaneucty?: number;
    kontrolauctu?: number;
    overeneucty?: number;
    stav?: EStavPozadavku;
    ppn?: boolean;
    rozsahppn?: ERozsahPPN;
    polozky: IPozadavkyPolozka[];
    offset: number;
    limit: number;
    count: number;
    order: string;
}

export interface IData {
    id?: number;
    idpolozky?: number;
    ucet?: string;
    idnabyvatele?: string;
    koducastnika?: string;
    zdrojdat?: string;
    zpusobporizeni?: string;
    idvcdcp?: string;
    typtransakce?: ETypTransakce;
    stavzadosti?: EStavPozadavku;
    offset?: number;
    limit?: number;
    order: string;
}

/* Vrátí detail zvoleného požadavku s položkami */
const uePozadavkyDetailApi = (id: number, data: IData) => {
    return axios({
        method: 'GET',
        url: `/UE/${id}/pozadavky`,
        params: {
            ...data
        }
    }).then((resp: AxiosResponse<IPozadavky>) => resp.data);
};

export interface IPozadavkyPolozkaDLT {
    castka: number;
    idpolozky: number;
    pocetcp: number;
    ucet: string;
    cislozastavnismlouvy: string;
    poznamka: string;
    zdrojdat: string;
    ppn?: boolean;
    zpusobporizeni: string;
    upozorneni: string;
    stav: string;
    meznidatumprozruseni: string;
    lzeevidovatod: string;
    uzivatel: string;
    sankce: boolean;
}

export enum ETypPrevodu {
    PXVNABEZZAPL = 'PXVNABEZZAPL', // verejna nabidka
    BEZZAPLACENI = 'BEZZAPLACENI', // Bez zaplacení
    PROTIZAPLACENI = 'PROTIZAPLACENI', // Proti zaplacení
    PROTIABEZZAPL = 'PROTIABEZZAPL' // obe
}

export interface IPozadavkyDLT {
    id: number;
    typ: ETypPozadavku;
    isin: string;
    datum: string;
    pocetcp: number;
    zaevidovanecp: number;
    nezaevidovanecp: number;
    vyporadanecp: number;
    nevyporadanecp: number;
    pocetuctu: number;
    zaevidovaneucty: number;
    nezaevidovaneucty: number;
    vyporadaneucty: number;
    nevyporadaneucty: number;
    kontrolauctu: number;
    overeneucty: number;
    sankce: boolean;
    stav: EStavPozadavku;
    typprevodu: ETypPrevodu;
    datuhr: string;
    cenacp: number;
    mena: string;
    bankucet: string;
    iban: string;
    minpoccp: number;
    stavdlt: string;
    pocetcpupisu: number;
    neuhrazenecp: number;
    neuhrazeneucty: number;
    zaevidovano: boolean;
    ppn?: boolean;
    rozsahppn?: ERozsahPPN;
    polozky: IPozadavkyPolozkaDLT[];
    count: number;
    meznidatum?: string;
    order: string;
    limit: number;
    offset: number;
}

export interface IDetailDLTinput {
    idpolozky?: string;
    ucet?: string;
    zpusobpor?: string;
    stav?: string;
    sankce?: boolean;
    pocetcp?: string;
    rliv?: string;
    offset: number;
    limit: number;
    order: string;
}

export const uePozadavkyDetailDLTApi = (id: number, data: IDetailDLTinput) => {
    return axios({
        method: 'GET',
        url: `/UED/${id}/pozadavky`,
        params: {
            ...data
        }
    }).then((resp: AxiosResponse<IPozadavkyDLT>) => resp.data);
};

export const uePozadavekDetailDLTApi = (id: number) => {
    return axios({
        method: 'GET',
        url: `/UED/${id}/pozadavek`
    }).then((resp: AxiosResponse<IPozadavkyDLT>) => resp.data);
};

export default uePozadavkyDetailApi;
